import { Box, Fab } from "@mui/material";
import { Outlet, useParams } from "react-router";
import { ThemeSwitchButton } from "../components/ThemeSwitchButton";
import CookieIcon from "@mui/icons-material/Cookie";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { useCookies } from "react-cookie";

export const DevLayout = () => {
  const { formId } = useParams<{ formId: string }>();
  const cookieName = `form-session-${formId}`;
  const [, , removeCookie] = useCookies([cookieName]);

  return (
    <>
      <Box>
        <Outlet />
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            right: 0,
            left: 0,
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            pointerEvents: "none",
            alignItems: "center",
            p: 2,
            minHeight: 0,
          }}
        >
          <Box sx={{ pointerEvents: "auto" }}>
            <Box sx={{ display: "flex", gap: 1, flexDirection: "column" }}>
              <Fab
                variant="extended"
                color="primary"
                onClick={() => {
                  window.location.reload();
                }}
              >
                <RotateLeftIcon sx={{ mr: 1 }} />
                Reload
              </Fab>
              <Fab
                variant="extended"
                color="secondary"
                onClick={() => {
                  removeCookie(cookieName, { path: "/" });
                  window.location.reload();
                }}
              >
                <CookieIcon sx={{ mr: 1 }} />
                Reset
              </Fab>
            </Box>
          </Box>
          <Box
            sx={{
              pointerEvents: "auto",
              alignSelf: "end",
            }}
          >
            <ThemeSwitchButton />
          </Box>
        </Box>
      </Box>
    </>
  );
};
